var map = {
	"./development.js": "lyyx",
	"./local.js": "RSUr",
	"./production.js": "Mi7Z",
	"./staging.js": "PjHw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ga4+";


//////////////////
// WEBPACK FOOTER
// ./src/env ^\.\/.*\.js$
// module id = Ga4+
// module chunks = 1